/**
 * Синхронизация чекбоксов родительской номинации и подноминаций (categories[]):
 * — клик по родителю выставляет всем детям то же состояние;
 * — если отмечены все подноминации, отмечается родитель, иначе родитель снимается.
 */
export function initNestedCategoriesCheckboxes(root = document) {
  root.querySelectorAll('ul.js-nested-categories-checkboxes:not([data-nested-categories-bound])').forEach((ul) => {
    ul.setAttribute('data-nested-categories-bound', '1');

    ul.querySelectorAll(':scope > li').forEach((li) => {
      const parentLabel = li.querySelector(':scope > label.form-check');
      const parentInput = parentLabel?.querySelector('input[type="checkbox"][name="categories[]"]');
      const subUl = Array.from(li.children).find(
        (el) => el.tagName === 'UL' && el.classList.contains('form__list')
      );

      if (!parentInput || !subUl) {
        return;
      }

      const childInputs = subUl.querySelectorAll('input[type="checkbox"][name="categories[]"]');
      if (!childInputs.length) {
        return;
      }

      const syncParentFromChildren = () => {
        parentInput.checked = Array.from(childInputs).every((i) => i.checked);
      };

      const syncChildrenFromParent = () => {
        childInputs.forEach((c) => {
          c.checked = parentInput.checked;
        });
      };

      parentInput.addEventListener('change', syncChildrenFromParent);
      childInputs.forEach((c) => c.addEventListener('change', syncParentFromChildren));
      syncParentFromChildren();
    });
  });
}

export default function initNestedCategoriesCheckboxesOnce() {
  initNestedCategoriesCheckboxes(document);
}
